import React from "react";
import cardStyles from "../fachoberschule/Card.module.css";
import {TbTargetArrow} from "react-icons/tb";
import {FaCircleCheck, FaRegHourglassHalf} from "react-icons/fa6";
import {FaRegCalendarCheck} from "react-icons/fa";
import {GrVulnerability} from "react-icons/gr";
import {LuBookOpenText} from "react-icons/lu";
import {BsClockHistory} from "react-icons/bs";
import {IoDocumentTextOutline} from "react-icons/io5";
import styles from "./Übersicht.module.css";


const features =[
    {
        icon:<TbTargetArrow />,
        title:"Zielgruppe",
        content:<div><p>Absolventen</p>
        <p>der Hauptschule</p></div>
    },
    {
        icon: <FaRegHourglassHalf />,
        title: "Dauer",
        content: "24 Monate"
    },
    {
        icon:<LuBookOpenText />,
        title: "Schulungsinhalte",
        content: <ul>
            <li>Politik & Wirtschaft</li>
            <li>Wirtschaftsenglisch</li>
            <li>Mathe/Wirtschaftsrechnen</li>
            <li>Deutsch</li>
            <li>Ethik</li>
            <li>Naturwissenschaften</li>
            <li>intensive EDV Schulung</li>
            <li>Sport</li>
            <li>verschiedene Lernfelder der Wirtschaft </li>
        </ul>
    },
    {
        icon:<FaCircleCheck />,
        title: "Voraussetzung",
        content:
            <div>
                <p>✔  qualifizierter Hauptschulabschluss</p>
                <br/>
                <p>✔ Noten:</p>
                <p>Mit mindestens befriedigenden Leistungen in zwei der Fächer Deutsch, Mathematik und Englisch, wobei in keinem der genannten Fächer die Leistungen schlechter als ausreichend sein dürfen</p>
                <br/>
                <p>✔  noch kein Besuch einer zweijährigen Berufsfachschule in einem anderem Schwerpunkt mehr als ein Jahr</p>
                <br/>
                <p>✔  das 18. Lebensjahr darf bei Schuljahresbeginn noch nicht vollendet sein</p>
            </div>,

    },
    {
        icon: <BsClockHistory />,
        title: "Unterrichtszeiten",
        content: <div><p>täglich Unterricht</p>
        <p>(32 - 34 Wochenstunden)</p></div>

    },
    {
        icon:<IoDocumentTextOutline />,
        title:"Dokumente zur Anmeldung",
        content: <ul>
            <li>Geburtsurkunde</li>
            <li>Impfnachweis</li>
            <li>letzten zwei Zeugnisse</li>
            <li>Bewerbungsschreiben</li>
            <li>Lebenslauf</li>
            <li>Eignungsgutachten</li>
        </ul>
    },
    {
        icon: <FaRegCalendarCheck />,
        title: "Beginn",
        content: <div><p>10. August 2026</p>
        <p>nach den Sommerferien</p></div>
    },

    {
        icon: <GrVulnerability />,
        title: "Ausbildungsziel",
        content: <div><p>mittlere Reife</p>
        <p>Schwerpunkt: Wirtschaft und Verwaltung</p></div>
    },
];



const FeaturesCard = ({ features }) => (
    <div className={cardStyles.card}>
        <div className={cardStyles.icon}>{features.icon}</div>
        <div className={cardStyles.title}>{features.title}</div>
        <div className={cardStyles.content}>{features.content}</div>
    </div>
);

const Ubersicht = () => {
    return(
        <div className="wrapper">
            <main className={styles.container}>
                <section className="wrapperContent">
                    <div style={{ marginBottom: "80px" }}>
                        <h1 style={{ fontWeight: "bold", color: "#488e62", textAlign: "left", marginBottom: 0 }}>
                          Übersicht
                        </h1>
                    </div>
                </section>
            </main>
                <div className={cardStyles.container}>
                    {features.map((features, index) => (
                        <FeaturesCard key={index} features={features} />
                    ))}
                </div>
        </div>
    )
}
export default Ubersicht;